// import config from '../../config/config';
//
// const { theme } = config;

const initialState = {
  // default: theme.default,
  // colors: theme.colors,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}
